import { Button } from "primereact/button"
import { Card } from "primereact/card"
import { Checkbox } from "primereact/checkbox";

const HomeHeader = ({ homePageMode, setHomePageMode, t, filterModes, setFilterModes }: any) => {

    const handleFilterChangeCompleted = () => {
        setFilterModes((prev: any) => {
            return {
                ...prev,
                low: prev.low === 1 ? 0 : 1,
                average: prev.average === 1 ? 0 : 1,
                high: prev.high === 1 ? 0 : 1
            }
        })
    };

    const handleFilterChangeMissed = () => {
        setFilterModes((prev: any) => {
            return {
                ...prev,
                missed: prev.missed === 1 ? 0 : 1,
            }
        })
    }

    return (
        <Card style={{ borderRadius: "24px", position: "relative" }}>
            <div className="flex justify-content-between">
                <div className='flex gap-2'>
                    <Button
                        label={t('today')}
                        onClick={() => setHomePageMode(0)}
                        icon={homePageMode === 0 ? <img src="/calendarIconForTodayWhite.svg" /> : <img src="/calendarIconForTodayDark.svg" />}
                        style={{
                            color: homePageMode === 0 ? "#FFFFFF" : "#2D3967",
                            backgroundColor: homePageMode === 0 ? "#6383F4" : "#FFFFFF",
                            height: '2.5rem',
                            width: '8rem',
                            borderRadius: "10px",
                            border: homePageMode === 0 ? "none" : "1px solid #2D3967",
                        }}
                    />
                    <Button
                        label={t('overall')}
                        onClick={() => setHomePageMode(1)}
                        icon={homePageMode === 1 ? <img src="/calendarIconForOveralWhite.svg" /> : <img src="/calendarIconForOveralDark.svg" />}
                        style={{
                            color: homePageMode === 1 ? "#FFFFFF" : "#2D3967",
                            backgroundColor: homePageMode === 1 ? "#6383F4" : "#FFFFFF",
                            height: '2.5rem',
                            width: '8rem',
                            borderRadius: "10px",
                            border: homePageMode === 1 ? "none" : "1px solid #2D3967",
                        }}
                    />
                </div>
                {homePageMode === 0 && 
                <div className='flex gap-2'>
                <Button
                    onClick={handleFilterChangeCompleted}
                    style={{
                        color: (filterModes.low && filterModes.average && filterModes.high) ? "#FFFFFF" : "#2D3967",
                        backgroundColor: (filterModes.low && filterModes.average && filterModes.high) ? "#576185" : "#EAEBF0",
                        height: '2.5rem',
                        width: '16rem',
                        borderRadius: "10px",
                        border: "none",
                        gap: "1rem",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Checkbox checked={(filterModes.low && filterModes.average && filterModes.high) === 1}></Checkbox>
                    <p className="m-0">{t('seeDone')}</p>
                </Button>

                <Button
                    onClick={handleFilterChangeMissed}
                    style={{
                        color: filterModes.missed ? "#FFFFFF" : "#2D3967",
                        backgroundColor: filterModes.missed ? "#576185" : "#EAEBF0",
                        height: '2.5rem',
                        width: '16rem',
                        borderRadius: "10px",
                        border: "none",
                        gap: "1rem",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Checkbox checked={filterModes.missed === 1}></Checkbox>
                    <p className="m-0">{t('seeMissed')}</p>
                </Button>
            </div>
            }
            </div>
        </Card>
    )
}

export default HomeHeader;